import { render, staticRenderFns } from "./ChangeLogs.vue?vue&type=template&id=bddb31e8"
import script from "./ChangeLogs.vue?vue&type=script&lang=js"
export * from "./ChangeLogs.vue?vue&type=script&lang=js"
import style0 from "./ChangeLogs.vue?vue&type=style&index=0&id=bddb31e8&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports